import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

export async function generateReceipt(appointmentUid) {
  const res = await axios.get(`${API_BASE}/receipts/generate/${encodeURIComponent(appointmentUid)}`,
    { headers: authHeader() });
  return res.data; // { html, filename, phone, customer_name, invoice_number }
}
